<div class="modal-header">
  <h4 class="modal-title whitespacenowrap">Manage LOI & Documents</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body document-body">
  <div class="border-div modal-data-box d-block align-item-center">
    <div class="dashboard-header-rt">
      <label class="be-label">
        Offer Placed By: <b>{{leadName}} </b>|     Offer Price:<b> {{'$ '+(offerPrice |number:0)}}</b>     |   Placed Date: <b>{{placedDate| date:'MM/dd/yyyy'}}</b>
      </label>
    </div>
  </div>
  <div class="border-div max-ht-300 white-bg" id="1031Dashboard">
    <div>
      <accordion [isAnimated]="true">
        <accordion-group heading="Upload Document" class="be-collapse-v2 prop-file-upload" [isOpen]="openUpload">
          <file-upload [uploadType]="fileUploadType" [messageDisplayes]="1" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [maxFiles]="5" [showList]="false" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes"></file-upload>
          <div class="table-responsive">
            <table class="table basictable fixedlayouttable" *ngIf="filesCollection.length > 0">
              <thead>
                <tr>
                  <th class="minwidth40">File</th>
                  <th class="minwidth40">Category</th>
                  <th class="minwidth20">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of filesCollection;let i = index" [attr.data-index]="i">
                  <td>
                    <p>{{file.name}}</p>
                  </td>
                  <td>
                    <label class="select">
                      <select class="form-control " [(ngModel)]="file.category">
                        <option value="0">--Select--</option>
                        <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
                      </select>
                      <i></i>
                    </label>
                  </td>
                  <td>
                    <a class="remove" href="javascript:void(0);" (click)="removeImage(i,$event)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </accordion-group>
      </accordion>
    </div>
  </div>
 
  <div class="border-div margin0">
    <div class="table-fixed table-v2">
      <div class="table-responsive margin0">
        <table class="table basictable row-border hover">
          <thead>
            <tr>
              <th style="width:50px">#</th>
              <th style="width: 150px">Action</th>
              <th>Document Title</th>
              <th>Category</th>
              <th>Uploaded By</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let doc of fileList; let i = index">
              <tr [ngClass]="{'highlighted' : doc.DocumentId == doc.MaxValue}">
                <td>
                  <p>{{i+1}}</p>
                </td>
                <td>
                  <a class="blueone" tooltip="Edit File" href="javascript:void(0);" (click)="openEditModal(EditFile,'',doc.DocumentId,doc.CategoryId)" style="font-size:15px">
                    <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                  </a>
                  <a *ngIf="doc.Path.includes('.pdf')" href="javascript:void(0);" tooltip="Preview" (click)="previews(preview,'pdf-view-modal', doc)" placement="top">
                    <i aria-hidden="true" class="fa fa-eye"></i>
                  </a>
                  <a triggers="hover" class="view" href={{doc.Path}} download="Document.pdf" target="_blank" ng-reflect-placement="top" ng-reflect-tooltip="Download" placement="top" tooltip="Download">
                    <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                  </a>
                  <a *ngIf="showRemoveButton" class="remove" href="javascript:void(0);" (click)="openModal(DeleteDocument,'',doc.DocumentId,n);" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                </td>
                <td>
                  <p>{{doc.FileName}}</p>
                </td>
                <td>
                  <p>{{doc.Category}}</p>
                </td>
                <td>
                  <p>{{doc.UploadedBy}}</p>
                </td>
                <td>
                  <p>
                    {{doc.Date| date:'MM/dd/yyyy hh:mm a'}}
                  </p>
                </td>
              </tr>
            </ng-container>
          </tbody>
          <tfoot>
            <tr *ngIf="fileList.length === 0">
              <td colspan="6" style="text-align: center; font-weight: normal; color: gray">
                <div class="nodata">
                  <i class="icofont icofont-warning icon"></i>
                  <p>No Documents Added</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
       
        <div class="text-right" *ngIf="filesCollection.length > 0">
          <button type="button" class="btn btn-default  btn-lg" (click)="onFilesClear();">Clear All</button>
          <button class="btn btn-success  btn-lg" (click)="uploadFiles();">Upload</button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #DeleteDocument>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Document</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-success" (click)="onRemoveDocument();modalRef.hide();">Yes</button>
    </div>
  </div>
</ng-template>
<ng-template #UploadConfirmation>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Please refresh this page once the file uploads are complete.</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-success" (click)="uploadFiles();">OK</button>
    </div>
  </div>
</ng-template>
<ng-template #preview>
  <div class="modal-header">
    <!--<h4 class="modal-title pull-left">{{docPreview.Name}}</h4>-->
    <button type="button" class="close pull-right" aria-label="Close" (click)="documentPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ngx-extended-pdf-viewer [src]="docPreview.Path" [showBookmarkButton]="false" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>
</ng-template>
<ng-template #EditFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit File</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefEdit.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">File Category</label>
      <label class="select">
        <select class="form-control" [(ngModel)]="categoryId">
          <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
        </select>
        <i></i>
      </label>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefEdit.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="UpdateDocCategory();">Save</button>
    </div>
  </div>
</ng-template>
<ng-template #UploadFileNew>
  <div class="modal-body modal-scroll-body padding30">
    <div class="offredetailspage section-margin">
      <div class="container">
        <div class="row">
          <button type="button" class="close pull-right file-pop-up-close" aria-label="Close" (click)="CloseFile();">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3 class="file-bluelabel margin-bottom-15">Upload</h3>
            <br />
            <div class="floatinghead clearfix">
              <file-upload [uploadType]="fileUploadType" [messageDisplayes]="1" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [maxFiles]="5" [showList]="false" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes"></file-upload>
            </div>
            <div class="table-responsive">
              <table class="table basictable fixedlayouttable" *ngIf="filesCollection.length > 0">
                <thead>
                  <tr>
                    <th class="minwidth40">File</th>
                    <th class="minwidth40">Category</th>
                    <th class="minwidth20">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let file of filesCollection;let i = index" [attr.data-index]="i">
                    <td>
                      <p>{{file.name}}</p>
                    </td>
                    <td>
                      <label class="select">
                        <select class="form-control " [(ngModel)]="file.category">
                          <option value="0">--Select--</option>
                          <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
                        </select>
                        <i></i>
                      </label>
                    </td>
                    <td>
                      <a class="remove" href="javascript:void(0);" (click)="removeImage(i,$event)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <div class="text-right" *ngIf="filesCollection.length > 0">
              <button type="button" class="btn btn-default  btn-lg" (click)="onFilesClear();">Clear All</button>
              <button class="btn btn-success  btn-lg" (click)="uploadFiles();">Upload File</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
